import React from "react";
import PropTypes from "prop-types";
import { TextInput } from "hesus-ui-kit";
import "./SearchBox.scss";
import { searchInputStyles } from "@utils/extra-style";

const SearchBox = (props) => {
  const {
    placeholder,
    value,
    onChange,
    inputClassName,
    containerClassName,
    name,
    id,
  } = props;

  return (
    <TextInput
      type="search"
      name={name}
      id={id}
      inputClass={
        inputClassName
          ? `${inputClassName} search-box-default-input`
          : "search-box-default-input"
      }
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      inputStyles={searchInputStyles}
      containerClass={
        containerClassName ? `${containerClassName} search-box` : "search-box"
      }
    />
  );
};

SearchBox.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  inputClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

SearchBox.defaultProps = {
  name: "",
  id: "",
  value: "",
  placeholder: "",
  inputClassName: "",
  containerClassName: "",
};

export default SearchBox;
